import React, { useCallback } from 'react';

import { Pressable, Text, View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { DETAIL_PROGRAMS_TAB, DETAIL_RECORDINGS_TAB } from 'config/testID';

import { isWeb } from 'utils/responsiveness';

import {
    DETAIL_PAGE_PROGRAMS_TAB,
    DETAIL_PAGE_RECORDINGS_TAB,
} from '../../languageConst';
import { DetailsPageSeasonsTab } from '../../types';
import styles from './styles';

type Props = {
    selectedTab: DetailsPageSeasonsTab;
    onTabPress(tabType: DetailsPageSeasonsTab): void;
};

const {
    ACCESSIBILITY: {
        DETAIL_PAGE: {
            ACCESSIBILITY_DETAIL_PAGE_PROGRAMS_TAB,
            ACCESSIBILITY_DETAIL_PAGE_RECORDINGS_TAB,
        },
    },
} = LANGUAGE_KEYS;

function SeasonsTabs({ selectedTab, onTabPress }: Props) {
    const { t } = useTranslation();

    const programsSelected = selectedTab === DetailsPageSeasonsTab.PROGRAMS;
    const recordingsSelected = selectedTab === DetailsPageSeasonsTab.RECORDINGS;

    const handleSelectPrograms = useCallback(() => {
        onTabPress(DetailsPageSeasonsTab.PROGRAMS);
    }, [onTabPress]);

    const handleSelectRecordings = useCallback(() => {
        onTabPress(DetailsPageSeasonsTab.RECORDINGS);
    }, [onTabPress]);

    return (
        <View style={styles.root}>
            <Pressable
                style={[
                    styles.seasonTab,
                    programsSelected && styles.seasonTabActive,
                ]}
                accessibilityLabel={t(ACCESSIBILITY_DETAIL_PAGE_PROGRAMS_TAB)}
                onPress={handleSelectPrograms}
                testID={DETAIL_PROGRAMS_TAB}
            >
                <Text
                    style={[
                        styles.seasonTabTitle,
                        programsSelected && styles.seasonTabTitleActive,
                    ]}
                    aria-hidden={isWeb}
                >
                    {t(DETAIL_PAGE_PROGRAMS_TAB)}
                </Text>
            </Pressable>
            <Pressable
                style={[
                    styles.seasonTab,
                    recordingsSelected && styles.seasonTabActive,
                ]}
                accessibilityLabel={t(ACCESSIBILITY_DETAIL_PAGE_RECORDINGS_TAB)}
                onPress={handleSelectRecordings}
                testID={DETAIL_RECORDINGS_TAB}
            >
                <Text
                    style={[
                        styles.seasonTabTitle,
                        recordingsSelected && styles.seasonTabTitleActive,
                    ]}
                    aria-hidden={isWeb}
                >
                    {t(DETAIL_PAGE_RECORDINGS_TAB)}
                </Text>
            </Pressable>
        </View>
    );
}

export default SeasonsTabs;
